import { VerifyForgotPasswordTokenMutation } from "@/generated/graphql";
import { graphql, HttpResponse } from "msw";

export const verifyForgotPasswordTokenHandler =
  graphql.mutation<VerifyForgotPasswordTokenMutation>(
    "verifyForgotPasswordToken",
    ({ query, variables }) => {
      if (!variables.input.token) {
        return HttpResponse.json({
          data: {
            verifyForgotPasswordToken: false,
          },
        });
      }
      return HttpResponse.json({
        data: {
          verifyForgotPasswordToken: true,
        },
      });
    }
  );
